import { useQuery } from '@tanstack/react-query';

import { apiKeysOptions } from '@/pages/Profile/TokenGeneration/api';

export const useLatestApiKey = () =>
  useQuery({
    ...apiKeysOptions.list(),
    staleTime: Infinity,
    select: apiKeys =>
      [...apiKeys]
        .sort((a, b) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime())
        .at(-1)?.prefixedRawApiKey
  }).data;
